export const API_URL = process.env.REACT_APP_API_URL;
export const ELIPAY_LOCAL_STORAGE = 'Elipay/POS';
export const PAYMENT_DURATION = 300;
